
import "bootstrap/dist/js/bootstrap.min.js";
import global from "../common/global.js";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import Divider from 'vux/src/components/divider/index.vue'


var vueapp = {};
var touchtime = new Date().getTime();

export default {
name: "index",
components: {
Marquee,
MarqueeItem
},
data() {
return {
showVdTask: false,
topInfo: [],
appver: 0,
phoneType: "",
validmoney: 0, //账户余额
todaymoney: 0, //今日收入
totalmoney: 0, //累计收入
isBreakPrison: false, //越狱
isiphone: true, //是否手机
isunder6: false, //是否ip6以下
isLimtPhoneType: false, //是否受限制的机型
isunderios9: false, //ios9以下
isunderios10: false,
userid: "88888888",
headimgurl: require("../assets/icon.png"),
systemAnnouncementstitle: "暂无消息",
showsystemAnnouncements: false, //是否显示系统通知
geteduserinfo: false 
};
},
methods: {
gotogamedd(){
var url =
global.hosturl +
"/api/index/ddzLink?token=" +
sessionStorage.getItem("sessionid") +
"&code=" +
sessionStorage.getItem("deviceid");

console.log(url);

url = global.addGetParam(url);
axios
.get(url)
.then(function(response) {

if (response.data.code == 0) {
document.location.href = response.data.data.url;

} else {
alert(response.data.msg);
}
})
.catch(function(err) {
alert(err);
});
},
gotogamedc() {
var url =
global.hosturl +
"/api/index/dclink?token=" +
sessionStorage.getItem("sessionid") +
"&code=" +
sessionStorage.getItem("deviceid");

console.log(url);

url = global.addGetParam(url);
axios
.get(url)
.then(function(response) {

if (response.data.code == 0) {
document.location.href = response.data.data.url;

} else {
alert(response.data.msg);
}
})
.catch(function(err) {
alert(err);
});
},
gotogamepcdd() {
var url =
global.hosturl +
"/api/index/pcddLink?token=" +
sessionStorage.getItem("sessionid") +
"&code=" +
sessionStorage.getItem("deviceid");

console.log(url);

url = global.addGetParam(url);
axios
.get(url)
.then(function(response) {

if (response.data.code == 0) {


window.android.openInBrowser(response.data.data.url);
} else {
alert(response.data.msg);
}
})
.catch(function(err) {
alert(err);
});
},
gotobill() {
this.$router.push({ name: "bill" });
},

getVdCnt(callBack) {
var url =
global.hosturl +
"/api/index/dkCount?token=" +
sessionStorage.getItem("sessionid");
url = global.addGetParam(url);
axios
.get(url)
.then(function(response) {

if (response.data.code == 0) {
callBack(response.data.data.count);
}
})
.catch(function(err) {});
},

clickfunc(type) {
if (type === 0) {
this.$router.push({
name: "tasklist",
query: {
phoneType: vueapp.phoneType
}
});
} else if (type === 1) {
this.$router.push({ name: "student" });
} else if (type === 2) {
this.$router.push({ name: "dytasklist" });
} else if (type == 3) {
vueapp.getVdCnt(function(cnt) {
window.bpnativeobj.getDkAd();
if (cnt <= 1) {
vueapp.showVdTask = false;
} else {
vueapp.showVdTask = true;
}
});
}
},
clickcarousel(pos) {
if (pos == 0) {
document.location.href =
"https://engine.tuirabbit.com/index/activity?appKey=uuNX4GQ6Xoi9mNG2yZcz3eYBRf1&adslotId=193506";
} else if (pos == 1) {
document.location.href = "https://s.jisushuru.com/?ac=bazijp&dl=698";
}

$(".carousel").carousel(); 
},
withDrawAciton() {},

doWithdraw(event) {

vueapp.$router.push({ name: "withdraw" });
event.stopPropagation();
},
donsignin() {
var curyear = new Date().getFullYear();
var curmonth = new Date().getMonth() + 1 + "";
var curday = new Date().getDate();
var signinsuccessdate = localStorage.getItem("signinsuccessdate");
if (curyear + ":" + curmonth + ":" + curday == signinsuccessdate) {
global.vuealert(vueapp.$vux, "今天已经签到成功，明天再来吧");
return;
}
var data = {
token: sessionStorage.getItem("sessionid")
};
global.addPostParam(data);
axios
.post(global.hosturl + "/api/user/signIn", data, {
headers: { "Content-Type": "application/json" }
})
.then(function(response) {

if (response.data.code == 0) {
vueapp.$layer
.dialog({
title: ["签到成功", "background:chocolate;color:white;"],
content: `
1、单日签到奖励
<br>
1.1 签到并完成2个任务，奖励0.1元
<br>
2、连续签到成功(每天需要成功完成2个任务)奖励
<br>
2.1 连续签到 5 天，奖励 0.2 元，累计奖励 0.5 + 0.2 = 0.7元
<br>
2.2 连续签到 10 天，奖励 0.4 元，累计奖励 0.7 + 0.5 + 0.4 = 1.6元
<br>
2.3 连续签到 15 天，奖励 0.6 元，累计奖励 1.6 + 0.5 + 0.6 = 2.7元
<br>
2.4 连续签到 20 天，奖励 0.8 元，累计奖励 2.7 + 0.5 + 0.8 = 4元
<br>
2.5 连续签到 25 天，奖励 1 元，累计奖励 4 + 0.5 + 1 = 5.5元
`,
shadeClose: true,
contentClass: "ruledlgstyle",
btn: ["确定"]
})
.then(function(res) {});


localStorage.setItem(
"signinsuccessdate",
curyear + ":" + curmonth + ":" + curday
);
} else {
global.vuealert(vueapp.$vux, response.data.msg);
}
})
.catch(function(err) {
alert(err);
});
},
getmoney() {},
getBindPhone() {},
getNotice() {},

putRequestInfo(userid, sessionid) {},

dobindwx(unionid, openid, userid, sessionid) {},

bindwx(userid, sessionid) {},
gotogame() {
this.$router.push({ name: "gametasklist" });
},

getuserinfo() {
var url =
global.hosturl +
"/api/user/index?token=" +
sessionStorage.getItem("sessionid");



url = global.addGetParam(url);

axios
.get(url)
.then(function(response) {
if (response.data.code == 0) {

vueapp.validmoney = response.data.data.balance;
vueapp.todaymoney = response.data.data.todayIncome;
vueapp.totalmoney = response.data.data.totalIncome;
sessionStorage.setItem(
"bindedalipay",
response.data.data.alipay.account
);
sessionStorage.setItem("bindedphone", response.data.data.phone);





sessionStorage.setItem("validmoney", vueapp.validmoney);





} else {
global.vuealert(
vueapp.$vux,
"获取用户信息失败:" + response.data.msg
);
}

})
.catch(function(err) {
global.vuealert(vueapp.$vux, "获取用户信息异常:" + err);
});
},

getNotice() {

var url =
global.hosturl +
"/api/index/notice?token=" +
sessionStorage.getItem("sessionid");


url = global.addGetParam(url);
axios
.get(url)
.then(function(response) {

if (response.data.code == 0) {

let arrNotices = response.data.data.list;
arrNotices.forEach(function(notice) {
vueapp.topInfo.push(notice.content);
});
}
})
.catch(function(err) {
console.error("getNotice error:" + err);
});
},

loginhost(response) {

var datas = {
openid: response.data.result.openid,
unionid: response.data.result.unionid,
nickname: response.data.result.nickname,
deviceModel: response.data.result.deviceModel,
avatar: response.data.result.avatar,
code: response.data.result.code,
city: response.data.result.city,
province: response.data.result.province,
teacherId: response.data.result.teacherId,
vpn: window.bpnativeobj.isVpnConnected() + "",
sim: window.bpnativeobj.isHasSimCard() + "",
imei: response.data.result.imei
};

global.addPostParam(datas);
axios
.post(global.hosturl + "/api/login/index", datas, {
headers: {
"Content-Type": "application/json"
}
})
.then(function(response) {

if (response.data.code == 0) {
sessionStorage.setItem("sessionid", response.data.data.token);
window.bpnativeobj.setToken(response.data.data.token);
sessionStorage.setItem("userid", response.data.data.userId);
vueapp.userid = response.data.data.userId;
sessionStorage.setItem("dyflag", response.data.data.dy);
if (response.data.data.is_new == 1) {
if (window.bpnativeobj.newPeopleRedPacket != undefined) {
window.bpnativeobj.newPeopleRedPacket();
}
}
vueapp.getuserinfo();
vueapp.getVdCnt(function(cnt) {
if (cnt <= 1) {
vueapp.showVdTask = false;
} else {
vueapp.showVdTask = true;
}
});
} else {
global.vuealert(vueapp.$vux, "登录失败:" + response.data.msg);
}

})
.catch(function(err) {
global.vuealert(vueapp.$vux, "登录异常:" + err);
});
},

dologin() {
axios.defaults.timeout = 3000;
axios
.get(global.clientBaseurl + "/getsign")
.then(function(response) {
axios.defaults.timeout = 10000;

if (response.data.result.avatar != "") {
vueapp.headimgurl = response.data.result.avatar;
sessionStorage.setItem("headimgurl", vueapp.headimgurl);
}

sessionStorage.setItem("deviceid", response.data.result.code);
sessionStorage.setItem("deviceimei", response.data.result.imei);
sessionStorage.setItem(
"deviceModel",
response.data.result.deviceModel
);
vueapp.appver = response.data.result.version;
if (
window.bpnativeobj.getVersionCode == undefined ||
window.bpnativeobj.getVersionCode() < 18
) {
vueapp.$layer
.dialog({
content: "蜜蜂试玩已经更新，请点击下方按钮获取新版本",
contentClass: "dialogstyle",
shadeClose: false,
btn: ["下载新版本"]
})
.then(function(res) {


window.bpnativeobj.dlAndInstalFile(
global.downloadUrl,
"/sdcard/bptask.apk"
);
});
return;
}

vueapp.phoneType = response.data.result.deviceModel;
vueapp.loginhost(response);
})
.catch(function(err) {
global.vuealert(vueapp.$vux, "获取登录信息异常:" + err);
axios.defaults.timeout = 10000;
});
}
},
created() {
vueapp = this;
},
mounted() {
$(".carousel").carousel(); 
axios.defaults.timeout = 10000;
this.getNotice();
this.dologin();
}
};



// WEBPACK FOOTER //
// ./src/components/index.vue